import http from './http';

// 查询员工列表
export const getEmployeeList = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/list',
    data,
  });
};

// 创建新员工
export const createEmployeeItem = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/create',
    data,
  });
};

// 发送手机绑定验证码-员工入职
export const sendBindSMSCode = (params) => {
  return http({
    method: 'GET',
    url: '/employee/management/sms/send',
    params,
  });
};

// 发送手机验证码-资料修改
export const sendInfoBindSMSCode = (params) => {
  return http({
    method: 'GET',
    url: '/employee/management/info/sms/send',
    params,
  });
};

// 校验验证码-员工入职
export const checkSMSCode = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/code/check/',
    data,
  });
};

// 校验验证码-员工资料修改
export const checkInfoSMSCode = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/info/code/check/',
    data,
  });
};

// 删除员工
export const deleteEmployeeItem = (id) => {
  return http({
    method: 'DELETE',
    url: `/employee/management/employee/${id}`,
  });
};

// 修改员工信息
export const updateEmployeeInfo = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/update',
    data,
  });
};

// 修改员工登录权限
export const updateEmployeeLogin = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/login/update',
    data,
  });
};

// 获取员工信息(查看)
export const getEmployeeInfo = (id) => {
  return http({
    method: 'GET',
    url: `/employee/management/query/employee/info/${id}`,
  });
};

// 获取员工信息(编辑)
export const getInfoForEdit = (id) => {
  return http({
    method: 'GET',
    url: `/employee/management/query/edit/employee/info/${id}`,
  });
};

// 获取入离职详情
export const getOperationDetail = (id) => {
  return http({
    method: 'GET',
    url: `/employee/management/employee/detail/${id}`,
  });
};

// 入职审批校验
export const validJoinInfo = (id) => {
  return http({
    method: 'POST',
    url: `/employee/management/join/valid/${id}`,
  });
};

// 提交入职审批
export const submitJoinRequest = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/join/approval/commit',
    data,
  });
};

// 入职审批通过
export const confirmJoinRequest = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/join/approval/pass',
    data,
  });
};

// 入职审批退回
export const refuseJoinRequest = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/join/approval/return',
    data,
  });
};

// 提交离职审批
export const submitLeaveRequest = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/leave/approval/commit',
    data,
  });
};

// 获取离职信息
export const getLeaveDetail = (id, extraHeader) => {
  return http({
    method: 'GET',
    url: `/employee/management/leave/detail/${id}`,
    headers: extraHeader || {},
  });
};

// 离职审批通过
export const confirmLeaveRequest = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/leave/approval/pass',
    data,
  });
};

// 离职审批退回
export const refuseLeaveRequest = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/leave/approval/return',
    data,
  });
};

// 获取岗位列表
export const getEmployeeJobList = (extraHeader?: {}) => {
  return http({
    method: 'GET',
    url: '/employee/management/queryJobByCommonCode',
    headers: extraHeader || {},
  });
};

// 钉钉组织邀请
export const postEmployeeDDInvites = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/dingtalk/org/invites',
    data,
  });
};

// 集团员工分页查询
export const getGroupEmployeeList = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/group/page',
    data,
  });
};

// 根据employeeId查询详情-资料
export const getEmployeeDetail = (id) => {
  return http({
    method: 'GET',
    url: `/employee/management/info/detail`,
    params: {
      employeeId: id,
    },
  });
};

// 提交区域审批-资料修改
export const submitEmployeeInfoAlter = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/info/submit',
    data,
  });
};

// 撤回区域审批-资料修改
export const recallEmployeeInfoAlter = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/info/recall',
    data,
  });
};

// 区域审批通过-资料修改
export const regionApprovePassInfoAlter = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/info/approveByRegional',
    data,
  });
};

// 区域审批拒绝-资料修改
export const regionApproveRejectInfoAlter = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/info/rejectByRegional',
    data,
  });
};

// 人事审批通过-资料修改
export const hrApprovePassInfoAlter = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/info/approveByHr',
    data,
  });
};

// 人事审批拒绝-资料修改
export const hrApproveRejectInfoAlter = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/info/rejectByHr',
    data,
  });
};

// 提交区域审批校验-资料修改
export const submitCheckInfoAlter = (data) => {
  return http({
    method: 'POST',
    url: '/employee/management/info/checkSame',
    data,
  });
};

// 工资单月度列表
export const fetchSalarySlipList = (data: { month: string }) => {
  return http({
    method: 'POST',
    url: '/employee/wages/month',
    data,
  });
};

// 工资单导入模板下载
export const getSalaryImportTemplate = (month) => {
  return http({
    method: 'GET',
    url: `/employee/wages/excel/template`,
    responseType: 'blob',
    params: {
      month,
    },
  });
};

// 工资单导入
export const importIndexValue = (id, data) => {
  return http({
    method: 'POST',
    url: `/employee/wages/import?id=${id}`,
    data,
  });
};

// 工资单详情获取
export const getSalarySlipDetail = (id) => {
  return http({
    method: 'GET',
    url: `/employee/wages/detail/${id}`,
  });
};

// 工资单保存
export const updateSalarySlip = (data) => {
  return http({
    method: 'POST',
    url: '/employee/wages/detail',
    data,
  });
};
